import { render, staticRenderFns } from "./BlockAutomatedPanelBuilder.vue?vue&type=template&id=0db26f5e&scoped=true"
import script from "./BlockAutomatedPanelBuilder.vue?vue&type=script&lang=js"
export * from "./BlockAutomatedPanelBuilder.vue?vue&type=script&lang=js"
import style0 from "./BlockAutomatedPanelBuilder.vue?vue&type=style&index=0&id=0db26f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db26f5e",
  null
  
)

export default component.exports